import { Routes } from '@angular/router';
import { BindQri } from './pages/bind-qri/bind-qri';
import { Dashboard } from './pages/dashboard/dashboard';
import { Transactions } from './pages/transactions/transactions';
import { TransactionsIso } from './pages/transactions-iso/transactions-iso';
import { TransactionsGp } from './pages/transactions-gp/transactions-gp';
import { ClientCredentials } from './pages/client-credentials/client-credentials';
import { Terminals } from './pages/terminals/terminals';
import { GpSftp } from './pages/gp-sftp/gp-sftp';
import { GpPresentments } from './pages/gp-presentments/gp-presentments';
import { GpPresentmentDetail } from './pages/gp-presentment-detail/gp-presentment-detail';
import { GpSettlements } from './pages/gp-settlements/gp-settlements';
import { GpSettlementRelated } from './pages/gp-settlement-related/gp-settlement-related';
import { GpSettlementTotals } from './pages/gp-settlement-totals/gp-settlement-totals';
import { GpChargebacks } from './pages/gp-chargebacks/gp-chargebacks';
import { GpChargebackDetail } from './pages/gp-chargeback-detail/gp-chargeback-detail';
import { GpReconciliations } from './pages/gp-reconciliations/gp-reconciliations';
import { Login } from './pages/login/login';
import { AuthCallback } from './pages/auth-callback/auth-callback';
import { authGuard } from './core/auth.guard';
import { DASHBOARD_GROUPS } from './core/auth-groups';

export const routes: Routes = [
  { path: 'login', component: Login },
  { path: 'auth/callback', component: AuthCallback },
  { path: 'logout', redirectTo: 'login' },
  { path: 'dashboard', component: Dashboard, canActivate: [authGuard] },
  {
    path: 'gp-conciliaciones',
    component: GpReconciliations,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionHpg] }
  },
  {
    path: 'gp-conciliacion/sftp',
    component: GpSftp,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionHpg] }
  },
  {
    path: 'gp-conciliacion/liquidaciones/presentaciones',
    component: GpPresentments,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionHpg] }
  },
  {
    path: 'gp-conciliacion/liquidaciones/presentaciones/:headerId',
    component: GpPresentmentDetail,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionHpg] }
  },
  { path: 'gp-conciliacion/liquidaciones/liquidaciones', component: GpSettlements, canActivate: [authGuard], data: { groups: [DASHBOARD_GROUPS.transactionHpg] } },
  { path: 'gp-conciliacion/liquidaciones/liquidaciones/:id/conceptos', component: GpSettlementRelated, canActivate: [authGuard], data: { groups: [DASHBOARD_GROUPS.transactionHpg], mode: 'concepts' } },
  { path: 'gp-conciliacion/liquidaciones/liquidaciones/:id/transacciones', component: GpSettlementRelated, canActivate: [authGuard], data: { groups: [DASHBOARD_GROUPS.transactionHpg], mode: 'transactions' } },
  { path: 'gp-conciliacion/liquidaciones/totales', component: GpSettlementTotals, canActivate: [authGuard], data: { groups: [DASHBOARD_GROUPS.transactionHpg] } },
  { path: 'gp-conciliacion/liquidaciones/contracargos', component: GpChargebacks, canActivate: [authGuard], data: { groups: [DASHBOARD_GROUPS.transactionHpg] } },
  { path: 'gp-conciliacion/liquidaciones/contracargos/:headerId', component: GpChargebackDetail, canActivate: [authGuard], data: { groups: [DASHBOARD_GROUPS.transactionHpg] } },
  {
    path: 'transactions',
    component: Transactions,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionHpg] }
  },
  {
    path: 'transactions-iso',
    component: TransactionsIso,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionIso] }
  },
  {
    path: 'transactions-gp',
    component: TransactionsGp,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.transactionHpg] }
  },
  {
    path: 'client-credentials',
    component: ClientCredentials,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.clientCredential] }
  },
  {
    path: 'terminales',
    component: Terminals,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal], section: 'terminals' }
  },
  {
    path: 'payway',
    component: Terminals,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal], section: 'payway' }
  },
  {
    path: 'configurar-terminal',
    component: Terminals,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal], section: 'terminal-configuration' }
  },
  {
    path: 'global-processing',
    component: Terminals,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal], section: 'global-processing' }
  },
  {
    path: 'global-processing/submerchant',
    component: Terminals,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal], section: 'global-processing', activeTab: 'submerchant' }
  },
  {
    path: 'global-processing/terminal-virtual',
    component: Terminals,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal], section: 'global-processing', activeTab: 'terminal-global-processing' }
  },
  { path: 'qr-interoperable', pathMatch: 'full', redirectTo: 'qr-interoperable/bind' },
  {
    path: 'qr-interoperable/bind',
    component: BindQri,
    canActivate: [authGuard],
    data: { groups: [DASHBOARD_GROUPS.terminal] }
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', redirectTo: 'dashboard' }
];
